

















































































import Vue from "vue";
import { mapState, mapActions } from "vuex";
import store from "../store/index";

export default Vue.extend({
	name: "SimilarListChart",
	computed: mapState({
		checkInfo: (state: any) => store.getters.getCheckInfo,
		productId: (state: any) => store.getters.getProductId,
	}),
	watch: {
		checkInfo(newQuestion, oldQuestion) {
			this.initSimilarListChart();
		},
	},
	data() {
		return {
			similarList: [],
		};
	},
	methods: {
		// 初始化相似片段分布图
		initSimilarListChart() {
			this.similarList = [];
			const problemList = this.checkInfo.hitDetailInfoList || [];
			problemList.forEach((item: any, index: number) => {
				const width = (item.length / this.checkInfo.reportModel.textLength) * 100 + "%";
				const left = (item.beginPosition / this.checkInfo.reportModel.textLength) * 100 + "%";
				let color = "#FF7272";
				// 根据不同的状态显示不同的颜色
				if (item.isSelfCited) {
					color = "#FFB92A";
				} else if (item.isReference) {
					color = "#4BD685";
				} else if (item.isLaw) {
					color = "#0000FF";
				}

				this.$set(this.similarList, index, {
					width,
					left,
					"background-color": color,
				});
			});
		},
	},
	mounted() {
		if (this.checkInfo.reportModel) {
			this.initSimilarListChart();
		}
	},
});
